import { render, staticRenderFns } from "./tempSendPreviewModel.vue?vue&type=template&id=60342b64&scoped=true&lang=pug&"
import script from "./tempSendPreviewModel.vue?vue&type=script&lang=js&"
export * from "./tempSendPreviewModel.vue?vue&type=script&lang=js&"
import style0 from "./tempSendPreviewModel.vue?vue&type=style&index=0&id=60342b64&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60342b64",
  null
  
)

export default component.exports